// extracted by mini-css-extract-plugin
export var backgroundCoverCenter = "heroWithLogo25-module--background-cover-center--3drBJ";
export var backgroundCoverTop = "heroWithLogo25-module--background-cover-top--33L0G";
export var backgroundContainTop = "heroWithLogo25-module--background-contain-top--3q4uX";
export var backgroundContainCenter = "heroWithLogo25-module--background-contain-center--24j-R";
export var backgroundContainLeft = "heroWithLogo25-module--background-contain-left--2o7i7";
export var section = "heroWithLogo25-module--section--1SNDw";
export var background = "heroWithLogo25-module--background--D6svv";
export var content = "heroWithLogo25-module--content--3ZYiJ";
export var fill = "heroWithLogo25-module--fill--3zcHz";
export var logo = "heroWithLogo25-module--logo--2WZL_";
export var yearText = "heroWithLogo25-module--year-text--3Q-Rc";
export var textContainer = "heroWithLogo25-module--text-container--3n9YD";
export var textDiv = "heroWithLogo25-module--text-div--3dNgN";
export var bannerText = "heroWithLogo25-module--banner-text--1J9vX";
export var line = "heroWithLogo25-module--line--234uJ";
export var countdownContainer = "heroWithLogo25-module--countdown-container--3fGZS";
export var countdownLabel = "heroWithLogo25-module--countdown-label--3sbcG";
export var countdownTo = "heroWithLogo25-module--countdown-to--1yCgE";